import Cookies from 'js-cookie'
let env = process.env.NODE_ENV

!Cookies.get('kf_api_url') && (Cookies.set('kf_api_url', 'https://test.usongshu.com/customerServer'))
!Cookies.get('kf_im_url') && (Cookies.set('kf_im_url', 'https://test.usongshu.com/imServer'))
let cookieApiUrl = Cookies.get('kf_api_url')
let cookieImUrl = Cookies.get('kf_im_url')

!Cookies.get('kf_admin_subDomain') && (Cookies.set('kf_admin_subDomain', 'test'))
let cookieSubDomain = Cookies.get('kf_admin_subDomain')

const server = {
  development: {
    subDomain: cookieSubDomain,
    api_url: cookieApiUrl,
    im_url: cookieImUrl,
    cookie_prefix: 'kf_'
  },
  test: {
    subDomain: cookieSubDomain,
    api_url: 'https://test.usongshu.com/customerServer',
    im_url: 'https://test.usongshu.com/imServer',
    cookie_prefix: 'kf_'
  },
  production: {
    subDomain: location.host.split('.')[0],
    api_url: 'https://platform.usongshu.com/customerServer',
    im_url: 'https://platform.usongshu.com/imServer',
    cookie_prefix: 'kf_'
  }
}

export default server[env]



// WEBPACK FOOTER //
// ./src/config/index.js